/** Website technical one-pagers: Select is PR21059, Plus is PR22057. */
export const APOE_SELECT_PRODUCT_IDS = ['PR21059'];
export const APOE_PLUS_PRODUCT_IDS = ['PR22057'];
export const APOE_PRODUCT_IDS = [...APOE_SELECT_PRODUCT_IDS, ...APOE_PLUS_PRODUCT_IDS];
